import React from 'react';
import { ImageIcon } from 'lucide-react';
export function EvidenceSms({
  sender,
  text
}: {
  sender: string;
  text: string;
}) {
  return <figure className="rounded-lg border border-border p-3" data-id="element-144" data-mp="2797933eyz6jf">
      <div className="mx-auto w-full max-w-[260px] rounded-[22px] border-4 border-slate-800 bg-slate-50 p-3" data-id="element-145" data-mp="2l1depvkhxv4m">
        <div className="mb-2 text-center text-[11px] font-semibold text-slate-600" data-id="element-146" data-mp="2g3243imdnglc">{sender}</div>
        <div className="rounded-2xl rounded-tl-sm bg-slate-200 px-3 py-2 text-[12px] leading-snug text-slate-800" data-id="element-147" data-mp="1sdhkqymbahbj">{text}</div>
        <div className="mt-1 text-[10px] text-slate-400" data-id="element-148" data-mp="1ocfkcegnrz7z">আজ ১০:২৪</div>
      </div>
      <figcaption className="mt-2 flex items-center gap-1.5 text-xs text-slate-500" data-id="element-149" data-mp="22bf7tisfq82k"><ImageIcon className="h-3.5 w-3.5" data-id="element-150" data-mp="1xaztanwf2uj0" /> sms_screenshot.png • ৪৮২ KB</figcaption>
    </figure>;
}